module.exports = __webpack_public_path__ + "media/images/lp_mv-bg_v3-091a8b7d1555d5057b29749a6690004b.webp";